export default {
  'nav.home': 'Início',
  'nav.services': 'Serviços',
  'nav.testimonials': 'Depoimentos',
  'nav.contact': 'Contato',
  'nav.whatsapp': 'WhatsApp',
  'nav.phone': 'Telefone',

  'hero.title': 'Transportando por Você',
  'hero.subtitle': 'Logística rápida, segura e eficiente para o seu negócio. Entregas pontuais em todo o Espírito Santo.',
  'hero.cta.primary': 'Solicitar Cotação',
  'hero.cta.secondary': 'Falar no WhatsApp',
  'hero.badge': 'Mais de 15 anos de experiência',

  'benefits.title': 'Nossos Serviços',
  'benefits.subtitle': 'Soluções completas em logística para atender todas as suas necessidades de transporte',
  'benefits.card1.title': 'Transporte de Cargas e Encomendas',
  'benefits.card1.desc': 'Profissionais capacitados e veículos 100% rastreados. Garantimos a qualidade do transporte desde a coleta do produto até a entrega ao destino final.',
  'benefits.card2.title': 'Carros Dedicados',
  'benefits.card2.desc': 'Ampla frota e equipe especializada para transporte efetuado por carros dedicados. Ideal para empresas que precisam de exclusividade e pontualidade.',
  'benefits.card3.title': 'Redespacho de Cargas',
  'benefits.card3.desc': 'Assegurando maior produtividade para outras transportadoras. Realizamos a entrega das encomendas ao cliente final com agilidade e segurança.',
  'benefits.card4.title': 'Rastreamento em Tempo Real',
  'benefits.card4.desc': 'Acompanhe sua carga de onde estiver. Sistema de rastreamento online com atualizações em tempo real sobre o status da entrega.',
  'benefits.card5.title': 'Cobertura Regional',
  'benefits.card5.desc': 'Atuamos em praticamente todo o Norte e Noroeste do Espírito Santo e na Grande Vitória, conectando sua empresa aos principais centros.',
  'benefits.card6.title': 'Suporte Dedicado',
  'benefits.card6.desc': 'Nossa central de atendimento está pronta para ajudar. Suporte humano e personalizado para tirar dúvidas e acompanhar suas entregas.',
  'benefits.cta': 'Saiba Mais',

  'testimonials.title': 'O Que Nossos Clientes Dizem',
  'testimonials.subtitle': 'Confiança construída com anos de entregas pontuais e serviço de excelência',

  'contact.title': 'Solicite Sua Cotação',
  'contact.subtitle': 'Preencha o formulário abaixo e nossa equipe entrará em contato em até 24 horas com a melhor proposta para você.',
  'contact.form.name': 'Nome Completo',
  'contact.form.email': 'E-mail',
  'contact.form.phone': 'Telefone / WhatsApp',
  'contact.form.service': 'Tipo de Serviço',
  'contact.form.service.option1': 'Transporte de Cargas',
  'contact.form.service.option2': 'Carro Dedicado',
  'contact.form.service.option3': 'Redespacho',
  'contact.form.service.option4': 'Outro',
  'contact.form.message': 'Mensagem',
  'contact.form.message.placeholder': 'Descreva sua necessidade de transporte...',
  'contact.form.submit': 'Enviar Solicitação',
  'contact.form.sending': 'Enviando...',
  'contact.form.success': 'Mensagem enviada com sucesso! Em breve entraremos em contato.',
  'contact.form.error': 'Ocorreu um erro ao enviar. Por favor, tente novamente.',
  'contact.form.spam': 'Obrigado! Sua mensagem foi recebida.',
  'contact.info.title': 'Outras Formas de Contato',
  'contact.info.phone': 'Central de Atendimento',
  'contact.info.whatsapp': 'WhatsApp',
  'contact.info.email': 'E-mail',
  'contact.info.address': 'Endereço',
  'contact.info.hours': 'Horário de Atendimento',
  'contact.info.hours.value': 'Segunda a Sexta, das 08h às 18h',

  'footer.about': 'Speed Courier - Logística em Geral. Mais de 15 anos transportando cargas e encomendas com segurança e pontualidade em todo o Espírito Santo.',
  'footer.links': 'Links Rápidos',
  'footer.services': 'Serviços',
  'footer.contact': 'Contato',
  'footer.follow': 'Siga-nos',
  'footer.copyright': '© {year} Speed Courier. Todos os direitos reservados.',
  'footer.legal': 'Política de Privacidade',

  'service.cargo': 'Transporte de Cargas',
  'service.dedicated': 'Carros Dedicados',
  'service.redispatch': 'Redespacho',
  'service.tracking': 'Rastreamento',
};